export const STEPPER_ACTIONS = {
  SUBMIT: "submit",
  CANCEL: "cancel",
  BACK: "back",
  GOTOSTEP: "gotostep",
}
